<template>
  <div>
    <template v-if="!$isDingDing">
      <a-form-item
        :label="`${qwTitTxt}：`"
        class="item"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 19 }"
      >
        <span
          v-if="datas.bind_qiwei === 0"
          class="company-name"
        > {{ $t('message["1260"]') }}</span>
        <div
          v-else
          style="display:inline;"
        >
          <template v-if="datas.bindQiweiInfo && datas.bindQiweiInfo.length">
            <div class="user-list">
              <div
                v-for="item in datas.bindQiweiInfo "
                :key="item.id"
                class="user-item"
              >
                <span
                  v-if="$store.state.qwWork === 'isWxWork'"
                  class="iframe-qw-name"
                >{{ item.userid }}</span>
                <span v-else>
                  <iframe
                    class="iframe-qw-name"
                    :src="item.iframeUrl"
                    scrolling="no"
                  />
                </span>
                <div
                  v-if="item.corp_full_name"
                  class="company-name account-tit-name"
                >
                  {{ item.corp_full_name }}
                </div>
              </div>
            </div>
          </template>
        <!-- <un-bind
          title="企业微信帐号"
          :name = "datas.bindQiweiInfo.name"
        /> -->
        </div>
      </a-form-item>
      <a-form-item
        :label="`${gcTitTxt}：`"
        class="item"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 19 }"
      >
        <span
          v-if="datas.bind_gcw === 0"
          class="company-name"
        > {{ $t('message["1260"]') }}</span>
        <div
          v-else
          class="row-cell-content"
        >
          <template v-if="datas.bindGcwInfo && datas.bindGcwInfo.bind_info">
            <span>{{ datas.bindGcwInfo.bind_info.name }}</span>
            <div class="company-name account-tit-name">
              {{ datas.bindGcwInfo.bind_info.comname }}
            </div>
          </template>
        <!-- <un-bind
          title="工厂网帐号"
          :name = "datas.bindGcwInfo.name"
        /> -->
        </div>
      </a-form-item>
    </template>
    <!-- 钉钉帐号 -->
    <a-form-item
      v-if="$isDingDing"
      :label="dingdingAccoutTit"
      class="item"
      :label-col="{ span: 2 }"
      :wrapper-col="{ span: 19 }"
    >
      <span
        v-if="datas.bind_dingding === 0"
        class="company-name"
      > {{ $t('message["1260"]') }}</span>
      <div
        v-else
        class="row-cell-content"
      >
        <template v-if="datas.bindDingdingInfo">
          <span>{{ datas.bindDingdingInfo.name }}</span>
          <div
            v-if="datas.bindDingdingInfo.corp_full_name"
            class="company-name account-tit-name"
          >
            {{ datas.bindDingdingInfo.corp_full_name }}
          </div>
        </template>
      </div>
    </a-form-item>
  </div>
</template>
<script>
// import Pop from '@/common/components/Pop'
// import UnBind from './UnBind'
import { mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      subUrl: '',
      popData: {}
    }
  },
  computed: {
    ...mapState('organization/person', ['itemData']),
    datas () {
      return this.itemData
    },
    dingdingAccoutTit () {
      return this.$t('message["242"]')
    },
    gcTitTxt () {
      return this.$t('message["391"]')
    },
    qwTitTxt () {
      return this.$t('message["720"]')
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.item {
  line-height: 40px;
  font-size: 14px;

  .item-cell {
    float: left;
    width: 320px;
    margin-right: 14px;
  }

  .sale-limit-row {
    width: 500px;
  }

  .item-cell label {
    display: inline-block;
    width: 70px;
    margin-right: 8px;
  }

  .item-cell label.item-tit-l {
    width: 98px;
    margin-right: 0;
  }
  .row-cell-content{
    line-height: 24px;
    padding-top: 4px;
  }
  .company-name {
    color: #b3b3b3;
  }
  .account-tit-name {
    padding-top: 8px;
  }
}
 .user-list::v-deep {
    margin-bottom: -4px;
    // margin-top: -6px;
    .user-item {
      padding-top: 4px;
      line-height: 24px;
      padding-bottom: 12px;
      box-sizing: content-box;
      .iframe-qw-name {
        display: inline;
        height: 24px;
        vertical-align: middle;
        width: 400px;
        border: 0;
      }
    }
  }
</style>
